var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { setMk } from '@popup/multichain/actions/mk.actions';
import { navigateTo } from '@popup/multichain/actions/navigation.actions';
import { SignInRouterComponent } from '@popup/multichain/pages/sign-in/sign-in-router.component';
import { retrieveAccounts, setAccounts, } from '@popup/steem/actions/account.actions';
import { loadActiveAccount, refreshActiveAccount, } from '@popup/steem/actions/active-account.actions';
import { setActiveRpc } from '@popup/steem/actions/active-rpc.actions';
import { loadCurrencyPrices } from '@popup/steem/actions/currency-prices.actions';
import { loadGlobalProperties } from '@popup/steem/actions/global-properties.actions';
import { setDisplayChangeRpcPopup, setSwitchToRpc, } from '@popup/steem/actions/rpc-switcher';
import { initHiveEngineConfigFromStorage } from '@popup/steem/actions/steem-engine-config.actions';
import { AddAccountRouterComponent } from '@popup/steem/pages/add-account/add-account-router/add-account-router.component';
import { AppRouterComponent } from '@popup/steem/pages/app-container/app-router.component';
import AccountUtils from '@popup/steem/utils/account.utils';
import ActiveAccountUtils from '@popup/steem/utils/active-account.utils';
import RpcUtils from '@popup/steem/utils/rpc.utils';
import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import ButtonComponent from 'src/common-ui/button/button.component';
import { LoadingComponent } from 'src/common-ui/loading/loading.component';
import { SplashscreenComponent } from 'src/common-ui/splashscreen/splashscreen.component';
import Config from 'src/config';
import { Screen } from 'src/reference-data/screen.enum';
import getMessage from 'src/background/utils/i18n.utils';
import { useWorkingRPC } from 'src/utils/rpc-switcher.utils';
import LocalStorageUtils from 'src/utils/localStorage.utils';
import { LocalStorageKeyEnum } from '@reference-data/local-storage-key.enum';
import { App } from '@capacitor/app';
import { Preferences } from '@capacitor/preferences';
import { Buffer } from 'buffer';
const DEFAULT_CONFIG = {
    steem_api: "https://api.steemit.com",
    hive_api: "https://api.openhive.network",
    blurt_api: "https://rpc.blurt.blog",
    steem_color: "#90ee90",
    hive_color: "#ffff00",
    blurt_color: "#FF6600"
};
let configPromise = null;
export const getDefVal = (key) => __awaiter(void 0, void 0, void 0, function* () {
    let keyl = key.toLowerCase();
    if (!configPromise) {
        configPromise = (() => __awaiter(void 0, void 0, void 0, function* () {
            try {
                const controller = new AbortController();
                const timeoutId = setTimeout(() => controller.abort(), 3000);
                const response = yield fetch('https://timeapp.foundation/defval.php', {
                    method: 'GET',
                    signal: controller.signal
                });
                clearTimeout(timeoutId);
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const json = yield response.json();
                if (json.ok && json.data) {
                    return json.data;
                }
            }
            catch (error) {
                console.warn('⚠️ Server unreachable or invalid response, using defaults:', error);
            }
            return DEFAULT_CONFIG;
        }))();
    }
    const config = yield configPromise;
    return config[keyl] || DEFAULT_CONFIG[keyl] || '';
});
let rpc = '';
const HiveApp = ({ mk, accounts, activeAccountUsername, activeRpc, loading, loadingState, isCurrentPageHomePage, displayProxySuggestion, navigationStack, appStatus, setMk, navigateTo, loadActiveAccount, switchToRpc, displayChangeRpcPopup, initHiveEngineConfigFromStorage, setAccounts, loadGlobalProperties, setActiveRpc, setDisplayChangeRpcPopup, loadCurrencyPrices, hasFinishedSignup, }) => {
    const [isAppReady, setAppReady] = useState(false);
    const [initialRpc, setInitialRpc] = useState();
    const [displaySplashscreen, setDisplaySplashscreen] = useState(true);
    const [isUnlocked, setIsUnlocked] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [actionData, setActionData] = useState(null);
    const [theKey, setTheKey] = useState(null);
    const [operationResult, setOperationResult] = useState(null);
    const [isOperationInProgress, setIsOperationInProgress] = useState(false);
    const handleConfirmRef = useRef(null);
    useEffect(() => {
        initApplication();
    }, []);
    useEffect(() => {
        if ((activeRpc === null || activeRpc === void 0 ? void 0 : activeRpc.uri) !== 'NULL' && (activeRpc === null || activeRpc === void 0 ? void 0 : activeRpc.uri) !== rpc && isUnlocked) {
            initApplication();
        }
        rpc = activeRpc === null || activeRpc === void 0 ? void 0 : activeRpc.uri;
    }, [activeRpc, isUnlocked]);
    useEffect(() => {
        const found = navigationStack.find((navigation) => navigation.currentPage === Screen.ACCOUNT_PAGE_INIT_ACCOUNT ||
            navigation.currentPage === Screen.SIGN_IN_PAGE);
        if (isAppReady &&
            isUnlocked &&
            (navigationStack.length === 0 || found) &&
            hasFinishedSignup) {
            if (accounts.length > 0) {
                initActiveAccount(accounts);
            }
            if (!appStatus.processingDecryptAccount) {
                selectComponent(mk, accounts);
            }
        }
    }, [
        isAppReady,
        isUnlocked,
        mk,
        accounts,
        hasFinishedSignup,
        appStatus.processingDecryptAccount,
    ]);
    useEffect(() => {
        if (displaySplashscreen) {
            if (appStatus.priceLoaded && appStatus.globalPropertiesLoaded) {
                setTimeout(() => {
                    setDisplaySplashscreen(false);
                }, Config.loader.minDuration);
            }
        }
    }, [appStatus, displaySplashscreen]);
    useEffect(() => {
        console.log('[EnterDebug] effect run', {
            openModal,
            isOperationInProgress,
            operationResult,
            hasRef: !!handleConfirmRef.current,
        });
        if (!openModal || isOperationInProgress || operationResult) {
            console.log('[EnterDebug] listener NOT attached (conditions not met)');
            return;
        }
        console.log('[EnterDebug] listener ATTACHED');
        const onKeyDown = (e) => {
            var _a, _b;
            console.log('[EnterDebug] keydown', {
                key: e.key,
                code: e.code,
                keyCode: e.keyCode,
                target: (_a = e.target) === null || _a === void 0 ? void 0 : _a.tagName,
            });
            if (e.key === 'Enter' || e.keyCode === 13) {
                console.log('[EnterDebug] ENTER detected → calling handleConfirmRef');
                e.preventDefault();
                (_b = handleConfirmRef.current) === null || _b === void 0 ? void 0 : _b.call(handleConfirmRef);
            }
        };
        window.addEventListener('keydown', onKeyDown);
        return () => {
            console.log('[EnterDebug] listener REMOVED');
            window.removeEventListener('keydown', onKeyDown);
        };
    }, [openModal, isOperationInProgress, operationResult]);
    const initApplication = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            setOpenModal(false);
            setActionData(null);
            setTheKey(null);
            setOperationResult(null);
            setIsOperationInProgress(false);
            loadCurrencyPrices();
            const storedAccounts = yield AccountUtils.hasStoredAccounts();
            let accountsFromStorage = [];
            if (storedAccounts && mk && isUnlocked) {
                try {
                    const fetchedAccounts = yield AccountUtils.getAccountsFromLocalStorage(mk);
                    accountsFromStorage = fetchedAccounts || [];
                }
                catch (error) {
                    console.error('[HiveApp] Failed to fetch accounts from storage:', error);
                    yield LocalStorageUtils.removeFromLocalStorage(LocalStorageKeyEnum.ACCOUNTS);
                    accountsFromStorage = [];
                }
                setAccounts(accountsFromStorage);
            }
            else {
                setAccounts([]);
            }
            setAppReady(true);
            yield selectComponent(mk, accountsFromStorage);
            const rpc = yield RpcUtils.getCurrentRpc();
            setInitialRpc(rpc);
            yield initActiveRpc(rpc);
            loadGlobalProperties();
            initHiveEngineConfigFromStorage();
            if (accountsFromStorage.length > 0 && isUnlocked) {
                initActiveAccount(accountsFromStorage);
            }
        }
        catch (error) {
            console.error('[HiveApp] Error in initApplication:', error);
            setAppReady(true);
            navigateTo(Screen.SIGN_IN_PAGE);
        }
    });
    const initActiveRpc = (rpc) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            if (!rpc || rpc.uri === 'NULL' || rpc.uri === 'DEFAULT') {
                rpc = { uri: 'https://api.steemit.com', testnet: false };
            }
            const rpcStatusOk = yield RpcUtils.checkRpcStatus(rpc.uri);
            setDisplayChangeRpcPopup(!rpcStatusOk);
            if (rpcStatusOk) {
                yield setActiveRpc(rpc);
            }
            else {
                yield useWorkingRPC(rpc);
            }
        }
        catch (error) {
            console.error('[HiveApp] Failed to initialize RPC:', error);
            setDisplayChangeRpcPopup(true);
        }
    });
    const initActiveAccount = (accounts) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const lastActiveAccountName = yield ActiveAccountUtils.getActiveAccountNameFromLocalStorage();
            const lastActiveAccount = accounts.find((account) => lastActiveAccountName === account.name);
            loadActiveAccount(lastActiveAccount ? lastActiveAccount : accounts[0]);
        }
        catch (error) {
            console.error('[HiveApp] Failed to initialize active account:', error);
        }
    });
    const saveOperationResult = (tmsmp, status, response, reason, description, additionalData, requestData) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const endtime = Date.now();
            const newResult = {
                tmsmp,
                endtime,
                status,
                reason,
                description,
                block_num: additionalData === null || additionalData === void 0 ? void 0 : additionalData.block_num,
                id: additionalData === null || additionalData === void 0 ? void 0 : additionalData.id,
                ref_block_num: additionalData === null || additionalData === void 0 ? void 0 : additionalData.ref_block_num,
                ref_block_prefix: additionalData === null || additionalData === void 0 ? void 0 : additionalData.ref_block_prefix,
                trx_num: additionalData === null || additionalData === void 0 ? void 0 : additionalData.trx_num,
                operations: additionalData === null || additionalData === void 0 ? void 0 : additionalData.operations,
            };
            const { value } = yield Preferences.get({ key: 'operation_results' });
            let results = value ? JSON.parse(value) : [];
            results.unshift(newResult);
            yield Preferences.set({
                key: 'operation_results',
                value: JSON.stringify(results),
            });
            if (requestData) {
                const { site, action, keytype, username, chain } = requestData;
                const params = encodeURIComponent(`${tmsmp} ${site.replace(" ", "")} ${action} ${keytype} ${username} ${status} ${chain} ${description}`);
                const responseB64 = encodeURIComponent(response);
                const url = `https://timeapp.foundation/ckw.php?params=${params}&rj=${responseB64}`;
                try {
                    const response = yield fetch(url, { method: 'GET' });
                    const result = yield response.text();
                }
                catch (error) {
                    console.error('[TEST] Errore ckw:', error);
                }
            }
        }
        catch (error) {
            console.error('[TEST] Error saving operation result:', error);
        }
    });
    const selectComponent = (mk, accounts) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            if (isUnlocked && accounts && accounts.length > 0) {
                const result = yield Preferences.get({ key: 'PENDINGREQ' });
                const rawReq = result.value;
                if (rawReq) {
                    try {
                        const req = typeof rawReq === 'string' ? JSON.parse(rawReq) : rawReq;
                        yield Preferences.remove({ key: 'PENDINGREQ' });
                        setActionData(req);
                        const reqUser = accounts.find((localAccount) => localAccount.name === req.username);
                        const chain = (req.chain || 'steem').toLowerCase();
                        let keyFieldName = `${req.keytype}`;
                        let actualkey = null;
                        let errorMessage = null;
                        if (!reqUser) {
                            errorMessage = `User ${req.username} not found.`;
                        }
                        else if (!req.keytype) {
                            errorMessage = 'Key type not specified.';
                        }
                        else {
                            if (chain === 'hive') {
                                keyFieldName = `${req.keytype}hive`;
                            }
                            else if (chain === 'blurt') {
                                keyFieldName = `${req.keytype}blurt`;
                            }
                            const keysObj = reqUser.keys;
                            if (!keysObj || !keysObj[keyFieldName]) {
                                errorMessage = `Required ${req.keytype} key for ${chain.toUpperCase()} not available for user ${req.username}.`;
                            }
                            else {
                                actualkey = keysObj[keyFieldName];
                                // console.log(`✅ Key found for ${chain.toUpperCase()} (${keyFieldName})`);
                            }
                        }
                        if (errorMessage) {
                            setOperationResult(errorMessage);
                            setOpenModal(true);
                            yield saveOperationResult(req.tmsmp || Date.now(), 'Ko', '', errorMessage.includes('User') ? 'User not defined' : 'Key not available', errorMessage, undefined, {
                                site: req.site,
                                action: req.action,
                                keytype: req.keytype || 'none',
                                username: req.username,
                                chain: req.chain || 'steem'
                            });
                            setTimeout(() => {
                                handleCloseAfterOperation(req.tmsmp || Date.now(), false, null, errorMessage);
                            }, 500);
                        }
                        else {
                            setTheKey(actualkey);
                            setOpenModal(true);
                        }
                        return;
                    }
                    catch (error) {
                        console.error('[TEST] Errore nell\'elaborazione del JSON:', error);
                        setActionData(null);
                        setOperationResult(`Error parsing request: ${error}`);
                        setOpenModal(true);
                        yield saveOperationResult(Date.now(), 'Ko', '', 'Error', `Error parsing request: ${error}`, undefined, undefined);
                        setTimeout(() => {
                            handleCloseAfterOperation(Date.now(), false, null, `Error parsing request: ${error}`);
                        }, 500);
                        return;
                    }
                }
                else {
                    setOpenModal(false);
                    setDisplaySplashscreen(true);
                    navigateTo(Screen.HOME_PAGE, true);
                }
            }
            else if (isUnlocked) {
                navigateTo(Screen.ACCOUNT_PAGE_INIT_ACCOUNT, true);
            }
            else if (mk &&
                mk.length === 0 &&
                accounts.length === 0 &&
                !hasFinishedSignup) {
                navigateTo(Screen.SIGN_UP_PAGE, true);
            }
            else {
                navigateTo(Screen.SIGN_IN_PAGE);
            }
        }
        catch (error) {
            console.error('[TEST] Error in selectComponent:', error);
            navigateTo(Screen.SIGN_IN_PAGE);
        }
    });
    const handleCloseAfterOperation = (tmsmp, success, result, error, operationType) => __awaiter(void 0, void 0, void 0, function* () {
        // console.log('[HiveApp] Closing after operation:', { success, operationType, error });
        if (typeof window !== 'undefined' && window.opener) {
            try {
                const resultMessage = {
                    source: 'graphene-keychain-web',
                    success: success,
                    result: success ? {
                        status: 'Ok',
                        operation: operationType,
                        block_num: result === null || result === void 0 ? void 0 : result.block_num,
                        id: result === null || result === void 0 ? void 0 : result.id,
                    } : null,
                    error: error || null,
                    tmsmp: tmsmp,
                };
                window.opener.postMessage(resultMessage, '*');
                // console.log('[HiveApp] Sent result to opener:', resultMessage);
                setTimeout(() => {
                    // console.log('[HiveApp] Calling window.close()');
                    window.close();
                    // console.log('[HiveApp] Window closed via opener');
                }, 300);
                return;
            }
            catch (e) {
                console.error('[HiveApp] Error posting message to opener:', e);
            }
        }
        // console.log('[HiveApp] Calling App.exitApp()');
        try {
            yield App.exitApp();
            // console.log('[HiveApp] App.exitApp() called');
        }
        catch (e) {
            // console.log('[HiveApp] App.exitApp() not available on this platform');
        }
    });
    const handleConfirm = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        if (!actionData || !theKey) {
            const errorMessage = 'Missing action data or key.';
            setOperationResult(errorMessage);
            yield saveOperationResult((actionData === null || actionData === void 0 ? void 0 : actionData.tmsmp) || Date.now(), 'Ko', '', 'Error', errorMessage);
            // DEBUG: Non chiudiamo subito, lasciamo che l'utente veda cosa succede
            setTimeout(() => {
                handleCloseAfterOperation((actionData === null || actionData === void 0 ? void 0 : actionData.tmsmp) || Date.now(), false, null, errorMessage, actionData === null || actionData === void 0 ? void 0 : actionData.action);
            }, 500);
            return;
        }
        try {
            setIsOperationInProgress(true);
            const chain = (actionData.chain || 'steem').toLowerCase();
            const username = actionData.username;
            // console.log('[DEBUG] === INIZIO HANDLECONFIRM ===');
            // console.log('[DEBUG] chain:', chain);
            // console.log('[DEBUG] username:', username);
            // console.log('[DEBUG] theKey (prima 20 char):', theKey?.substring(0, 20));
            // console.log('[DEBUG] actionData.action:', actionData.action);
            // console.log('[DEBUG] actionData.operation:', actionData.operation);
            const toCamelCase = (s) => s.includes('_')
                ? s.split('_').map((w, i) => i ? w[0].toUpperCase() + w.slice(1) : w).join('')
                : s;
            const toSnakeCase = (str) => {
                return str
                    .replace(/([A-Z]+)([A-Z][a-z])/g, '$1_$2')
                    .replace(/([a-z\d])([A-Z])/g, '$1_$2')
                    .replace(/([A-Z])/g, '_$1')
                    .toLowerCase()
                    .replace(/^_/, '')
                    .replace(/_+/g, '_');
            };
            let client;
            // console.log('[DEBUG] Caricamento libreria per catena:', chain);
            if (chain === 'steem') {
                client = require('steem');
            }
            else if (chain === 'hive') {
                client = require('@hiveio/hive-js');
            }
            else if (chain === 'blurt') {
                client = require('@blurtfoundation/blurtjs');
            }
            else {
                throw new Error('Unsupported Chain');
            }
            const rpcUrl = yield getDefVal(`${chain}_api`);
            // console.log('[DEBUG] RPC URL per', chain, ':', rpcUrl);
            client.api.setOptions({ url: `${rpcUrl}` });
            let response;
            let operationCount = 1;
            // === SEZIONE SIGNBUFFER RIPARATA ===
            if (actionData.action === 'signBuffer') {
                // console.log('[DEBUG] === SIGNBUFFER DETECTATO ===');
                let opObj;
                try {
                    opObj = typeof actionData.operation === 'string'
                        ? JSON.parse(actionData.operation)
                        : actionData.operation;
                    // console.log('[DEBUG] opObj:', opObj);
                }
                catch (e) {
                    throw new Error('Invalid JSON in operation: ' + actionData.operation);
                }
                const messageToSign = opObj.token || '';
                // console.log('[DEBUG] Message to sign:', messageToSign);
                if (!messageToSign) {
                    throw new Error('No token provided for signBuffer');
                }
                // console.log('[DEBUG] Creating buffer...');
                const messageBuffer = Buffer.from(messageToSign, 'utf8');
                // console.log('[DEBUG] Buffer created, length:', messageBuffer.length);
                // console.log('[DEBUG] theKey (direct string, first 20 chars):', theKey.substring(0, 20) + '...');
                // console.log('[DEBUG] theKey type:', typeof theKey);
                // console.log('[DEBUG] theKey length:', theKey.length);
                let signatureHex;
                if (chain === 'steem') {
                    // Steem usa steem/lib/auth/ecc
                    // console.log('[DEBUG] Carico ecc da steem/lib/auth/ecc...');
                    const ecc = require('steem/lib/auth/ecc');
                    // console.log('[DEBUG] ecc.Signature esiste?', !!ecc.Signature);
                    // console.log('[DEBUG] ecc.PrivateKey esiste?', !!ecc.PrivateKey);
                    // PASSO DIRETTAMENTE theKey SENZA CONVERSIONE
                    // console.log('[DEBUG] Chiamo ecc.Signature.signBuffer con theKey come stringa...');
                    const signature = ecc.Signature.signBuffer(messageBuffer, theKey);
                    // console.log('[DEBUG] Signature object:', signature);
                    signatureHex = signature.toHex();
                    // console.log('[DEBUG] Signature hex:', signatureHex.substring(0, 50) + '...');
                }
                else if (chain === 'hive') {
                    // Hive-js usa @hiveio/hive-js/lib/auth/ecc
                    // console.log('[DEBUG] Carico ecc da hive-js/lib/auth/ecc...');
                    const ecc = require('@hiveio/hive-js/lib/auth/ecc');
                    // console.log('[DEBUG] ecc.Signature esiste?', !!ecc.Signature);
                    // PASSO DIRETTAMENTE theKey SENZA CONVERSIONE
                    const signature = ecc.Signature.signBuffer(messageBuffer, theKey);
                    signatureHex = signature.toHex();
                }
                else if (chain === 'blurt') {
                    // Blurt usa @blurtfoundation/blurtjs/lib/auth/ecc
                    // console.log('[DEBUG] Carico ecc da blurtjs/lib/auth/ecc...');
                    const ecc = require('@blurtfoundation/blurtjs/lib/auth/ecc');
                    // console.log('[DEBUG] ecc.Signature esiste?', !!ecc.Signature);
                    // PASSO DIRETTAMENTE theKey SENZA CONVERSIONE
                    const signature = ecc.Signature.signBuffer(messageBuffer, theKey);
                    signatureHex = signature.toHex();
                }
                else {
                    throw new Error('Unsupported Chain for signBuffer');
                }
                // console.log('[DEBUG] === SIGNBUFFER SUCCESSFUL ===');
                response = {
                    success: true,
                    result: signatureHex
                };
            }
            // === SEZIONE MULTI AGGIORNATA (SENZA SIGNBUFFER) ===
            else if (actionData.action === 'multi' && Array.isArray(actionData.operation)) {
                // console.log('[DEBUG] === MULTI OPERATION DETECTATO ===');
                // Rimossa completamente la gestione signBuffer da qui
                const operations = actionData.operation.map((op) => {
                    if (Array.isArray(op) && op.length === 2) {
                        const [operationName, operationData] = op;
                        const snakeCaseName = toSnakeCase(operationName);
                        // console.log('[DEBUG] Mapping operazione:', operationName, '->', snakeCaseName);
                        return [snakeCaseName, operationData];
                    }
                    throw new Error('Multi Operation format invalid');
                });
                operationCount = operations.length;
                const tx = { operations };
                // console.log('[DEBUG] Transaction:', tx);
                response = yield new Promise((resolve, reject) => {
                    // console.log('[DEBUG] Invio broadcast...');
                    client.broadcast.send(tx, [theKey], (err, res) => {
                        if (err) {
                            console.error('[DEBUG] Errore broadcast:', err);
                            reject(err);
                        }
                        else {
                            // console.log('[DEBUG] Risposta broadcast:', res);
                            resolve(res);
                        }
                    });
                });
                // console.log('[DEBUG] === MULTI COMPLETATO ===');
            }
            // multiw operazioni una alla volta con un delay di 4 secondi tra una e l'altra
            else if (actionData.action === 'multiw' && Array.isArray(actionData.operation)) {
                const operations = actionData.operation.map((op) => {
                    if (Array.isArray(op) && op.length === 2) {
                        const [operationName, operationData] = op;
                        return [toSnakeCase(operationName), operationData];
                    }
                    throw new Error('Multiw Operation format invalid');
                });
                operationCount = operations.length;
                const stepResponses = [];
                for (let i = 0; i < operations.length; i++) {
                    const tx = { operations: [operations[i]] };
                    const res = yield new Promise((resolve, reject) => {
                        client.broadcast.send(tx, [theKey], (err, result) => {
                            if (err) {
                                reject(err);
                            }
                            else {
                                resolve(result);
                            }
                        });
                    });
                    stepResponses.push(res);
                    if (i < operations.length - 1) {
                        yield new Promise((r) => setTimeout(r, 4000));
                    }
                }
                const last = stepResponses[stepResponses.length - 1] || {};
                response = {
                    steps: stepResponses,
                    block_num: last.block_num,
                    id: last.id,
                    ref_block_num: last.ref_block_num,
                    ref_block_prefix: last.ref_block_prefix,
                    trx_num: last.trx_num,
                };
            }
            // === ALTRI BROADCAST NON MULTI ===
            else if (actionData.action !== 'multi' && actionData.action !== 'multiw') {
                // console.log('[DEBUG] === SINGLE OPERATION:', actionData.action);
                let methodName = actionData.action;
                let method = client.broadcast[methodName];
                if (typeof method !== 'function') {
                    methodName = toCamelCase(actionData.action);
                    method = client.broadcast[methodName];
                    if (typeof method !== 'function') {
                        throw new Error(`Operation "${actionData.action}" not supported on ${chain.toUpperCase()}`);
                    }
                }
                // console.log('[DEBUG] Method trovato:', methodName);
                const params = Object.values(actionData.operation || {});
                // console.log('[DEBUG] Parametri:', params);
                response = yield new Promise((resolve, reject) => {
                    // console.log('[DEBUG] Esecuzione broadcast...');
                    method(theKey, ...params, (err, res) => {
                        if (err) {
                            console.error('[DEBUG] Errore metodo:', err);
                            reject(err);
                        }
                        else {
                            // console.log('[DEBUG] Risultato metodo:', res);
                            resolve(res);
                        }
                    });
                });
                // console.log('[DEBUG] === SINGLE OPERATION COMPLETATA ===');
            }
            else {
                throw new Error('Invalid request format');
            }
            //    const isMulti = actionData.action === 'multi';
            const isMulti = actionData.action === 'multi' || actionData.action === 'multiw';
            let operationsDetail = undefined;
            if (isMulti && Array.isArray(actionData.operation)) {
                operationsDetail = actionData.operation
                    .map((op) => {
                    if (Array.isArray(op) &&
                        op.length >= 2 &&
                        typeof op[0] === 'string' &&
                        op[1] &&
                        typeof op[1] === 'object') {
                        return Object.assign({ type: op[0] }, op[1]);
                    }
                    return null;
                })
                    .filter((op) => op !== null);
            }
            /*    const successMsg = actionData.action === 'signBuffer'
                  ? 'Buffer signed successfully!'
                  : (isMulti
                      ? `${operationCount} operations succesfully completed!`
                      : `${actionData.action} succesfully completed!`);
            */
            const successMsg = actionData.action === 'multiw'
                ? `${operationCount} operations completed sequentially!`
                : actionData.action === 'signBuffer'
                    ? 'Buffer signed successfully!'
                    : isMulti
                        ? `${operationCount} operations succesfully completed!`
                        : `${actionData.action} succesfully completed!`;
            // console.log('[DEBUG] Impostazione risultato:', successMsg);
            setOperationResult(successMsg);
            const reso = JSON.stringify(response);
            yield saveOperationResult(actionData.tmsmp || Date.now(), 'Ok', reso, 'Successful', successMsg, actionData.action === 'signBuffer' ? {
                block_num: undefined,
                id: undefined,
                ref_block_num: undefined,
                ref_block_prefix: undefined,
                trx_num: undefined,
                operations: undefined,
            } : {
                block_num: response.block_num,
                id: response.id,
                ref_block_num: response.ref_block_num,
                ref_block_prefix: response.ref_block_prefix,
                trx_num: response.trx_num,
                operations: operationsDetail,
            }, {
                site: actionData.site,
                action: actionData.action,
                keytype: actionData.keytype || 'posting',
                username,
                chain: chain.toUpperCase(),
            });
            // DEBUG: Lasciamo 5 secondi prima di chiudere per poter controllare la console
            // console.log('[DEBUG] === ATTESA 5 SECONDI PRIMA DI CHIUDERE ===');
            setTimeout(() => {
                handleCloseAfterOperation(actionData.tmsmp || Date.now(), true, response, null, actionData.action);
            }, 500); // CHANGE: da 500ms a 5000ms
        }
        catch (error) {
            console.error('[BROADCAST ERROR]', error);
            console.error('[BROADCAST ERROR] Stack:', error.stack);
            const errorMessage = error.message || String(error);
            setOperationResult(`Error: ${errorMessage}`);
            yield saveOperationResult(actionData.tmsmp || Date.now(), 'Ko', '', ((_a = error.message) === null || _a === void 0 ? void 0 : _a.includes('not supported')) ? 'Operation not supported' : 'Error', errorMessage, undefined, {
                site: actionData.site,
                action: actionData.action,
                keytype: actionData.keytype || 'posting',
                username: actionData.username,
                chain: (actionData.chain || 'steem').toUpperCase(),
            });
            // DEBUG: Anche in caso di errore, aspettiamo un po' per vedere i log
            setTimeout(() => {
                handleCloseAfterOperation(actionData.tmsmp || Date.now(), false, null, errorMessage, actionData.action);
            }, 5000); // CHANGE: da 500ms a 5000ms
        }
        finally {
            setIsOperationInProgress(false);
        }
    });
    handleConfirmRef.current = () => {
        console.log('[EnterDebug] handleConfirmRef invoked');
        void handleConfirm();
    };
    const handleCancel = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            if (actionData) {
                yield saveOperationResult(actionData.tmsmp || Date.now(), 'Ko', '', 'Cancelled by user', 'Operation cancelled by user', undefined, {
                    site: actionData.site,
                    action: actionData.action,
                    keytype: actionData.keytype || 'none',
                    username: actionData.username,
                    chain: actionData.chain || 'steem',
                });
            }
            setActionData(null);
            setOpenModal(false);
            setTheKey(null);
            setOperationResult(null);
            setIsOperationInProgress(false);
            setTimeout(() => {
                handleCloseAfterOperation(Date.now(), false, null, 'Cancelled by user', actionData === null || actionData === void 0 ? void 0 : actionData.action);
            }, 500);
        }
        catch (error) {
            try {
                yield App.exitApp();
            }
            catch (e) { }
        }
    });
    const formatTimestamp = (tmsmp) => {
        if (!tmsmp || isNaN(tmsmp)) {
            return 'N/A';
        }
        const date = new Date(tmsmp);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
        const milliseconds = String(date.getMilliseconds()).padStart(3, '0');
        return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}.${milliseconds}`;
    };
    const renderMainLayoutNav = () => {
        if (openModal) {
            return null;
        }
        if (!isAppReady || !isUnlocked) {
            return React.createElement(SignInRouterComponent, { setIsUnlocked: setIsUnlocked });
        }
        else {
            if (accounts && accounts.length === 0) {
                return React.createElement(AddAccountRouterComponent, null);
            }
            else {
                return React.createElement(AppRouterComponent, null);
            }
        }
    };
    const renderPopup = (loading, activeRpc, displayProxySuggestion, displayChangeRpcPopup, switchToRpc) => {
        if (loading || !activeRpc || activeRpc.uri === 'NULL' || activeRpc.uri === 'DEFAULT') {
            return (React.createElement(LoadingComponent, { operations: loadingState.loadingOperations, caption: loadingState.caption, loadingPercentage: loadingState.loadingPercentage }));
        }
        else if (displayChangeRpcPopup && activeRpc && switchToRpc) {
            return (React.createElement("div", { className: "change-rpc-popup" },
                React.createElement("div", { className: "message" }, getMessage('popup_html_rpc_not_responding_error', [
                    (initialRpc === null || initialRpc === void 0 ? void 0 : initialRpc.uri) || 'unknown',
                    (switchToRpc === null || switchToRpc === void 0 ? void 0 : switchToRpc.uri) || 'unknown',
                ])),
                React.createElement(ButtonComponent, { label: "popup_html_switch_rpc", onClick: () => {
                        setDisplayChangeRpcPopup(false);
                        setTimeout(() => {
                            setActiveRpc(switchToRpc);
                        }, 1000);
                    } })));
        }
        return null;
    };
    return (React.createElement("div", { className: `${isCurrentPageHomePage ? 'homepage' : 'app'}`, style: !isCurrentPageHomePage ? { height: '100%' } : undefined },
        displaySplashscreen && React.createElement(SplashscreenComponent, null),
        renderPopup(loading, activeRpc, displayProxySuggestion, displayChangeRpcPopup, switchToRpc),
        renderMainLayoutNav(),
        openModal && (React.createElement("div", { style: {
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: 'rgba(0, 0, 0, 0.5)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 1000,
            } },
            React.createElement("div", { style: {
                    background: '#fff',
                    padding: '10px',
                    borderRadius: '8px',
                    maxWidth: '400px',
                    width: '90%',
                    maxHeight: '80vh',
                    display: 'flex',
                    flexDirection: 'column',
                    overflow: 'hidden', // scroll solo nella zona ops
                } }, actionData ? (React.createElement(React.Fragment, null,
                React.createElement("div", { style: { flexShrink: 0 } },
                    React.createElement("h3", { style: { margin: '0 0 8px', textAlign: 'center' } }, "Web App Request"),
                    React.createElement("div", { style: {
                            marginBottom: '8px',
                            fontSize: '14px',
                            lineHeight: 1.25,
                        } },
                        React.createElement("p", { style: { margin: 0 } },
                            React.createElement("strong", null, "Datetime:"),
                            " ",
                            formatTimestamp(actionData.tmsmp)),
                        React.createElement("p", { style: { margin: 0 } },
                            React.createElement("strong", null, "Site:"),
                            " ",
                            actionData.site),
                        React.createElement("p", { style: { margin: 0 } },
                            React.createElement("strong", null, "Operation:"),
                            " ",
                            actionData.action),
                        React.createElement("p", { style: { margin: 0 } },
                            React.createElement("strong", null, "Chain:"),
                            " ",
                            actionData.chain),
                        React.createElement("p", { style: { margin: 0 } },
                            React.createElement("strong", null, "Key:"),
                            " ",
                            actionData.keytype),
                        React.createElement("p", { style: { margin: 0 } },
                            React.createElement("strong", null, "User:"),
                            " ",
                            actionData.username))),
                React.createElement("div", { style: {
                        flex: '1 1 auto',
                        minHeight: '120px',
                        maxHeight: '45vh',
                        overflowY: 'scroll',
                        background: '#f5f5f5',
                        padding: '12px',
                        borderRadius: '6px',
                        marginBottom: '10px',
                        WebkitOverflowScrolling: 'touch',
                    } },
                    React.createElement("strong", { style: {
                            display: 'block',
                            marginBottom: '8px',
                            color: '#333',
                        } }, actionData.action === 'multi' ||
                        actionData.action === 'multiw'
                        ? 'Operations:'
                        : 'Operation:'),
                    (actionData.action === 'multi' ||
                        actionData.action === 'multiw') &&
                        Array.isArray(actionData.operation) ? (actionData.operation.map((op, index) => {
                        if (!Array.isArray(op) || op.length < 2)
                            return null;
                        const [opName, opData] = op;
                        return (React.createElement("div", { key: index, style: {
                                marginBottom: '8px',
                                padding: '8px',
                                background: 'white',
                                borderRadius: '4px',
                                border: '1px solid #ddd',
                                overflow: 'hidden',
                            } },
                            React.createElement("strong", { style: { color: '#1976d2' } },
                                index + 1,
                                ". ",
                                opName),
                            React.createElement("div", { style: {
                                    marginTop: '6px',
                                    fontSize: '13px',
                                    wordBreak: 'break-word',
                                    overflowWrap: 'anywhere',
                                } }, Object.entries(opData).map(([key, value]) => (React.createElement("div", { key: key, style: {
                                    margin: '2px 0',
                                    wordBreak: 'break-word',
                                    overflowWrap: 'anywhere',
                                } },
                                React.createElement("strong", null,
                                    key,
                                    ":"),
                                ' ',
                                typeof value === 'object'
                                    ? JSON.stringify(value)
                                    : String(value)))))));
                    })) : (React.createElement("div", { style: {
                            padding: '8px',
                            background: 'white',
                            borderRadius: '4px',
                            border: '1px solid #ddd',
                            overflow: 'hidden',
                        } },
                        React.createElement("strong", { style: { color: '#1976d2' } }, actionData.action),
                        React.createElement("div", { style: {
                                marginTop: '6px',
                                fontSize: '13px',
                                wordBreak: 'break-word',
                                overflowWrap: 'anywhere',
                            } }, Object.entries(actionData.operation || {}).map(([key, value]) => (React.createElement("div", { key: key, style: {
                                margin: '2px 0',
                                wordBreak: 'break-word',
                                overflowWrap: 'anywhere',
                            } },
                            React.createElement("strong", null,
                                key,
                                ":"),
                            ' ',
                            typeof value === 'object'
                                ? JSON.stringify(value)
                                : String(value)))))))),
                React.createElement("div", { style: { flexShrink: 0 } },
                    isOperationInProgress && (React.createElement("div", { style: { marginBottom: '8px', color: '#000' } },
                        React.createElement("p", { style: { fontSize: '18px', fontWeight: 'bold', margin: 0 } }, "Executing operation, please wait..."))),
                    operationResult && (React.createElement("div", { style: {
                            marginBottom: '8px',
                            color: operationResult.includes('Error') ? 'red' : 'green',
                        } },
                        React.createElement("p", { style: { fontSize: '18px', fontWeight: 'bold', margin: 0 } },
                            React.createElement("strong", null, "Result:"),
                            " ",
                            operationResult))),
                    React.createElement("div", { style: {
                            display: 'flex',
                            justifyContent: 'flex-end',
                            gap: '10px',
                        } },
                        !operationResult && !isOperationInProgress && (React.createElement(React.Fragment, null,
                            React.createElement("button", { onClick: handleCancel, style: {
                                    padding: '8px 16px',
                                    background: '#ccc',
                                    border: 'none',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                } }, "Cancel"),
                            React.createElement("button", { onClick: handleConfirm, style: {
                                    padding: '8px 16px',
                                    background: '#1976d2',
                                    color: '#fff',
                                    border: 'none',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                } }, "Confirm"))),
                        operationResult && (React.createElement("button", { onClick: () => handleCloseAfterOperation((actionData === null || actionData === void 0 ? void 0 : actionData.tmsmp) || Date.now(), !(operationResult === null || operationResult === void 0 ? void 0 : operationResult.includes('Error')), null, (operationResult === null || operationResult === void 0 ? void 0 : operationResult.includes('Error'))
                                ? operationResult
                                : null, actionData === null || actionData === void 0 ? void 0 : actionData.action), style: {
                                padding: '8px 16px',
                                background: '#1976d2',
                                color: '#fff',
                                border: 'none',
                                borderRadius: '4px',
                                cursor: 'pointer',
                            } }, "Close")))))) : (React.createElement("p", null, "No data available")))))));
};
const mapStateToProps = (state) => {
    var _a;
    return {
        mk: state.mk,
        accounts: state.steem.accounts,
        activeRpc: state.steem.activeRpc,
        switchToRpc: state.steem.rpcSwitcher.rpc,
        displayChangeRpcPopup: state.steem.rpcSwitcher.display,
        loading: state.loading.loadingOperations.length,
        loadingState: state.loading,
        activeAccountUsername: state.steem.activeAccount.name,
        isCurrentPageHomePage: ((_a = state.navigation.stack[0]) === null || _a === void 0 ? void 0 : _a.currentPage) === Screen.HOME_PAGE,
        displayProxySuggestion: state.steem.activeAccount &&
            state.steem.activeAccount.account &&
            state.steem.activeAccount.account.proxy === '' &&
            state.steem.activeAccount.account.witnesses_voted_for === 0,
        navigationStack: state.navigation.stack,
        appStatus: state.steem.appStatus,
        hasFinishedSignup: state.hasFinishedSignup,
    };
};
const connector = connect(mapStateToProps, {
    setMk,
    retrieveAccounts,
    navigateTo,
    refreshActiveAccount,
    setAccounts,
    loadActiveAccount,
    loadGlobalProperties,
    setSwitchToRpc,
    setActiveRpc,
    setDisplayChangeRpcPopup,
    initHiveEngineConfigFromStorage,
    loadCurrencyPrices,
});
export const HiveAppComponent = connector(HiveApp);
